import { registerPlugin, Capacitor } from '@capacitor/core';

const SwipeBack = registerPlugin('SwipeBack');

/**
 * Enable/disable native iOS swipe-back gesture.
 * No-op on Android & Web.
 * 
 * @param {boolean} enabled
 * @returns {Promise<void>}
 */
export const setSwipeBackEnabled = async (enabled) => {
  if (Capacitor.getPlatform() !== 'ios') return;
  try {
    await SwipeBack.setEnabled({ enabled });
  } catch (error) {
    console.warn('[SwipeBack] Gagal toggle gesture:', error);
  }
};
